<template>
  <b-container>
    <b-row>
      <b-col class="px-0">
        <b-card
          v-if="config"
          no-body
          header="Images"
          class="mt-0">
          <b-card-body>
            <b-form>
              <logo-upload
                ref="lightActive"
                v-model="config.capLogos.svgLightActive"
                :can-edit="canBrandingEdit"
                label="Light Active"
                ref-id="lightActive">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Light Active"
                    :description="config.capLogos.rasterLightActive" />
                </template>
              </logo-upload>
              <hr>
              <logo-upload
                ref="lightInactive"
                v-model="config.capLogos.svgLightInactive"
                :can-edit="canBrandingEdit"
                label="Light Inactive"
                ref-id="lightInactive">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Light Inactive"
                    :description="config.capLogos.rasterLightInactive" />
                </template>
              </logo-upload>
              <hr>
              <logo-upload
                ref="darkActive"
                v-model="config.capLogos.svgDarkActive"
                :can-edit="canBrandingEdit"
                label="Dark Active"
                ref-id="darkActive">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Dark Active"
                    :description="config.capLogos.rasterDarkActive" />
                </template>
              </logo-upload>
              <hr>
              <logo-upload
                ref="darkInactive"
                v-model="config.capLogos.svgDarkInactive"
                :can-edit="canBrandingEdit"
                label="Dark Inactive"
                ref-id="darkInactive">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Dark Inactive"
                    :description="config.capLogos.rasterDarkInactive" />
                </template>
              </logo-upload>
              <hr>
              <logo-upload
                ref="spotLogo"
                v-model="config.capLogos.svgSpotLogo"
                :can-edit="canBrandingEdit"
                label="Spot Logo"
                ref-id="spotLogo">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Spot Logo"
                    :description="config.capLogos.rasterSpotLogo" />
                </template>
              </logo-upload>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import {mapGetters} from "vuex"
  import LogoUpload from "./LogoUpload"

  export default {
    name: "CapLogosForm",
    components: {
      LogoUpload,
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
          "canBrandingEdit",
      ]),
      config: {
        get: function () {
          if (!this.value.capLogos) {
            return {
              capLogos: {},
            }
          }
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
      isDisabled() {
        return !this.canBrandingEdit
      },
    },
    watch: {
      'config.capLogos.svgLightActive'(newValue) {
        if (newValue) {
          this.config.capLogos.rasterLightActive = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
          console.log("updating rasterLightActive", this.config.capLogos.rasterLightActive)
        }
      },
      'config.capLogos.svgLightInactive'(newValue) {
        if (newValue) {
          this.config.capLogos.rasterLightInactive = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
          console.log("updating rasterLightInactive", this.config.capLogos.rasterLightInactive)
        }
      },
      'config.capLogos.svgDarkActive'(newValue) {
        if (newValue) {
          this.config.capLogos.rasterDarkActive = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
          console.log("updating rasterDarkActive", this.config.capLogos.rasterDarkActive)
        }
      },
      'config.capLogos.svgDarkInactive'(newValue) {
        if (newValue) {
          this.config.capLogos.rasterDarkInactive = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
          console.log("updating rasterDarkInactive", this.config.capLogos.rasterDarkInactive)
        }
      },
      'config.capLogos.svgSpotLogo'(newValue) {
        if (newValue) {
          this.config.capLogos.rasterSpotLogo = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
          console.log("updating rasterSpotLogo", this.config.capLogos.rasterSpotLogo)
        }
      },
    },
  }
</script>

<style scoped>

  .card {
    margin: 1.5rem 0;
  }

  .asset-action-icon {
    cursor: pointer;
    max-height: 16px;
    max-width: 16px;
  }

</style>
